import { render } from "./1.PointsStep.vue?vue&type=template&id=7f9032e8"
import script from "./1.PointsStep.vue?vue&type=script&lang=js"
export * from "./1.PointsStep.vue?vue&type=script&lang=js"

import "./1.PointsStep.vue?vue&type=style&index=0&id=7f9032e8&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__